module.exports = __webpack_public_path__ + "Videoiconnew.e8049dd.png";